import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getUserInfo } from 'spark-state/common/user/userReducer';
import {
    configureSupportLinkURL,
    privacyPolicyLinkURL,
    termsOfUseLinkURL,
    versionLink
} from 'spark-api/safetyLetter/commonSafetyLetterService';
import { getMappedEnterpriseData } from 'spark-state/common/app/reducer';
import IQVIALogo from '../../../assets/images/IQVIALogo-Tricolor.svg';
import { getVersionNumber } from 'spark-state/enterprise/enterpriseReducer';

const FooterBar = styled.footer`
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #F8F9FB;
    margin-bottom: 25px;
    font-size: 14px;
    border-top: 1px solid #F2F2F2;
    border-bottom: 1px solid #F2F2F2;
    text-align: left;
    
    & a {
        color: #0768FD;
        text-decoration: none;
        display: inline-block;
    }

    & a:hover {
        text-decoration: underline;
    }

    & .ctmsRefresh {
        font-size: 1.2em;
    }

    & .vl {
        padding-left: 24px;
        height: 25px;
    }

    & .copyrightText{
        color: #595959;
        padding-right:36px;
    }
`;
const FooterSplitToolbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: ${({ alignment = 'center' }) =>
        alignment === 'top' ? 'flex-start' : alignment === 'bottom' ? 'flex-end' : alignment};
    height: 60px;
`;

const Footer = () => (
    <FooterBar>   
         <FooterSplitToolbar> 
       <div>
            <img style={{verticalAlign:'middle',height:38, width:100,paddingLeft:24}} src={IQVIALogo} alt=''></img>  
                <span className="vl"></span>
                <VersionNumber />
                <span className="vl"></span>
                <SupportLink />
               
                <span className="vl"></span>
                <a href={`${termsOfUseLinkURL}`} target="_blank" rel="noopener noreferrer"> {/* SAF-18222- Vulnerability Scan Issue fixes - reverse tab nabbing */}
                   Terms of Use
                </a>
               
                <span className="vl"></span>
                
                <a href={`${privacyPolicyLinkURL}`} target="_blank" rel="noopener noreferrer"> {/* SAF-18222- Vulnerability Scan Issue fixes - reverse tab nabbing */}
                    Privacy
                </a>
                
                <span className="vl"></span>
              </div>  

                <div>
                <span  className='copyrightText'>
                {`\u00A9 ${new Date().getFullYear()} IQVIA Inc`}
                </span>
                </div>
                </FooterSplitToolbar>
    </FooterBar>
);

export default Footer;

export const SupportLink = () => {
    const location = useLocation();
    const user = useSelector(getUserInfo);
    const mappedEnterprise = useSelector(getMappedEnterpriseData);
    const sponsor = mappedEnterprise && mappedEnterprise.filter(
        (i) => i.entId === parseInt(user.enterpriseId, 10));
    const supportURL = sponsor && sponsor.length ? (sponsor[0].supportURL ? sponsor[0].supportURL.split('?')[0] : '') : configureSupportLinkURL;
    const supportLink = `${supportURL}?emailAddress=${user.email}&firstName=${
        user.given_name
    }&lastName=${user.family_name}&moduleName=${process.env.MODULE_NAME}&redirectURL=${
        process.env.PUBLIC_URL
    }${location.pathname}${sponsor && sponsor.length ? `&sponsor=${encodeURIComponent(sponsor[0].entName)}` : ''}`;

    // SAF-18222- Vulnerability Scan Issue fixes - reverse tab nabbing for support link
    return (
        <a href={supportLink} target="_blank" rel="noopener noreferrer"> 
            Support
        </a> 
    );
};

const VersionNumber = () => {
    // SAF-19125- Safety - Displaying the Version Number
    const version = useSelector(state => {
        const v = getVersionNumber(state);
        return v ? v : '';
    });
    const displayVersion = `Version ${version}`;
    return (
        <a href={`${versionLink}`} target="_blank" rel="noopener noreferrer"> 
            {displayVersion} 
        </a> 
    );
};